"use client"

import React, { useState, useEffect, useRef } from 'react';
import { fabric } from 'fabric';

import delayedAction from './../utils/delayedAction';
import { stateObjToGrad } from './../utils/gradientTools';
import __ from './../utils/translation';

import $ from "jquery";
import ColorPicker, { useColorPicker } from 'react-best-gradient-color-picker';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import { Label } from './ui/label';
import { Checkbox } from './ui/checkbox';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Plus } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { supbaseManager, getUserId } from './../API';

const SelectionColorSettings = ({ canvas, activeSelection }) => {

  const [color, setColor] = useState('rgba(210,211,213,1)');
  const { getGradientObject } = useColorPicker(color, setColor);
  const gradientObject = getGradientObject();
  const [applyAll, setApplyAll] = useState(false);
  const [myColors, setMyColors] = useState([]);
  const [colorTables, setColorTables] = useState([]);
  const [selectedTableId, setSelectedTableId] = useState("default");

  const legacyColorsRef = useRef([]);
  const colorTablesRef = useRef([]);
  const selectedTableRef = useRef(localStorage.getItem("myColorsTable") || "default");

  const [gradient] = useState({
    type: 'linear',
    angle: 90,
    colorStops: [
      { offset: 0, color: 'rgba(0, 0, 0, 1)', id: 0 },
      { offset: 1, color: 'rgba(255, 0, 0, 1)', id: 1 }
    ],
    reset: true
  })

  useEffect(() => {
    if (activeSelection._objects) {
      for (let i = 0; i < activeSelection._objects.length; i++) {
        if (activeSelection._objects[i].lockMovementX) {
          activeSelection.lockMovementX = true;
          activeSelection.lockMovementY = true;
          activeSelection.lockScalingX = true;
          activeSelection.lockScalingY = true;
          activeSelection.lockRotation = true;
          activeSelection.hasControls = false;
          break;
        }
      }
    }

    if (!activeSelection.fill) return;
    if (!activeSelection.fill.colorStops) {
      let color = new fabric.Color(activeSelection.fill);
      let colorRgba = color.getSource();
      $("#colorPicker").val(rgbToHex(color._source[0], color._source[1], color._source[2]));
    }

    var objW = activeSelection.width * activeSelection.scaleX * 0.0445;
    var objH = activeSelection.height * activeSelection.scaleY * 0.0445;

    //$("#obj-svg-width").text("Largura: " + objW.toFixed(2) + "cm");
    //$("#obj-svg-height").text("Altura: " + objH.toFixed(2) + "cm");

    $("#dim-final").text("largura: " + objW.toFixed(1) + "cm | Altura: " + objH.toFixed(1) + "cm")

    if (activeSelection.colorMain)
      setColor(activeSelection.colorMain);
    else {
      if (activeSelection.fill.colorStops) {
      } else {
        setColor(activeSelection.fill);
      }
    }

    if (!document.getElementById("list-colors"))
      return;

    var cloned = document.getElementById("list-colors").cloneNode(true);

    if ($("#my-colors-svg").children().length == 0)
      document.getElementById("my-colors-svg").appendChild(cloned);
  }, [activeSelection])

  const handleColorChange = (color) => {
    setColor(color);

    activeSelection.colorMain = color;

    if (color.includes("gradient")) {
      if (gradientObject.isGradient) {
        gradient.type = gradientObject.gradientType.replace("-gradient", "");
        gradient.angle = parseInt(gradientObject.degrees.replace("deg", ""));
        gradient.colorStops = [];

        for (let j = 0; j < gradientObject.colors.length; j++) {
          gradient.colorStops.push({
            color: gradientObject.colors[j].value,
            offset: gradientObject.colors[j].left / 100,
            id: j
          });
        }

        let fabricGrad = stateObjToGrad(gradient, activeSelection.width, activeSelection.height, fabric);

        if (activeSelection._objects) {
          for (let k = 0; k < activeSelection._objects.length; k++) {
            activeSelection._objects[k].set('fill', fabricGrad);
          }
        } else {
          activeSelection.set('fill', fabricGrad);
        }
      }
    } else {
      if (applyAll) {
        window.fabricCanvas._objects.forEach((obj) => {
          if (obj.default && !obj.id.includes("png")) {
            if (obj.id != "bk" && obj.id != "BK") {
              obj.set("fill", color);
            }
          }
        });
      } else if (activeSelection._objects) {
        for (let l = 0; l < activeSelection._objects.length; l++) {
          activeSelection._objects[l].set('fill', color);
        }
      } else {
        activeSelection.set('fill', color);
      }
    }

    canvas.renderAll();

    delayedAction(1200, () => {
      canvas.trigger('object:modified');
    });

    if (window.is_iframe)
      window['updateCanvas']();
  }

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }

  /*  $(".color-type").bind("click", function () {
      $(".color-type").css("text-decoration", "none");
      $(this).css("text-decoration", "underline");
  
      if ($(this).data("type") == "color") {
        $("#panel-my-colors").css("display", "none");
        $("#panel-color").css("display", "flex");
      } else {
        $("#panel-my-colors").css("display", "flex");
        $("#panel-color").css("display", "none");
      }
    });*/

  const handleChange = (event) => {
    setApplyAll(event);
  };

  const handleMyColors = () => {
    window["handleMyColors"]();
    loadColorTables();
  };

  const loadColorTables = async () => {
    try {
      const res = await supbaseManager("get", "color-tables", null, getUserId());

      if (!Array.isArray(res)) return;

      const parsed = res.map((row) => {
        try {
          const content = JSON.parse(row.content);
          content.id = String(row.id);
          return content;
        } catch (e) {
          return null;
        }
      }).filter(Boolean);

      colorTablesRef.current = parsed;
      setColorTables(parsed);

      // volta pro padrão se a tabela salva não existe mais
      if (selectedTableRef.current !== "default" && !parsed.some((t) => t.id === selectedTableRef.current)) {
        handleTableSelect("default");
        return;
      }

      applyTableColors(selectedTableRef.current);
    } catch (e) {
      console.error("[MyColors] loadColorTables:", e);
    }
  };

  const applyTableColors = (tableId) => {
    selectedTableRef.current = tableId;
    setSelectedTableId(tableId);

    if (tableId === "default") {
      setMyColors(legacyColorsRef.current);
    } else {
      const table = colorTablesRef.current.find((t) => t.id === tableId);

      const colors = ((table && table.colors) || []).map((c) => {
        const [r, g, b] = colorToRgb(c.hex);
        return { hex: c.hex, r, g, b };
      });

      setMyColors(colors);
    }
  };

  const handleTableSelect = (value) => {
    localStorage.setItem("myColorsTable", value);
    applyTableColors(value);
  };

  const handleManageTables = () => {
    $("#modal-color-table").css("display", "block");
  };

  useEffect(() => {
    setSelectedTableId(selectedTableRef.current);
    loadColorTables();

    // atualiza a lista quando o usuário fecha o gerenciador de tabelas
    const handler = () => loadColorTables();
    $("body").on("click", "#close-modal-color-table", handler);
    return () => {
      $("body").off("click", "#close-modal-color-table", handler);
    };
  }, []);

  useEffect(() => {
    window.populateMyColors = (arrayColors) => {
      if (!Array.isArray(arrayColors)) return;

      const colors = arrayColors.map((hex) => {
        const [r, g, b] = colorToRgb(hex);
        return { hex, r, g, b };
      });

      legacyColorsRef.current = colors;

      // só sobrescreve a grade se estiver na tabela padrão
      if (selectedTableRef.current === "default") {
        setMyColors(colors);
      }
    };

    return () => {
      delete window.populateMyColors;
    };
  }, []);

  function colorToRgb(color) {
    const tempElement = document.createElement('div');
    tempElement.style.color = color;
    document.body.appendChild(tempElement);

    const rgb = getComputedStyle(tempElement).color;
    document.body.removeChild(tempElement);

    return rgb.match(/\d+/g).map(Number);;
  }

  return (
    <Card className="border-0 shadow-none bg-transparent">
      <CardContent className="p-0 space-y-4">
        <Tabs defaultValue="colors" className="w-full">
          <TabsList className="w-full grid grid-cols-2 h-10">
            <TabsTrigger
              value="colors"
              id="option-color"
              data-type="color"
              className="text-sm font-medium"
            >
              {__('Colors')}
            </TabsTrigger>
            <TabsTrigger
              value="my-colors"
              data-type="myColor"
              className="text-sm font-medium"
              onClick={handleMyColors}
            >
              {__('My Colors')}
            </TabsTrigger>
          </TabsList>

          <div className="flex items-center gap-3 py-3 px-1">
            <Checkbox
              id="apply-all"
              checked={applyAll}
              onCheckedChange={handleChange}
            />
            <Label htmlFor="apply-all" className="text-sm text-muted-foreground cursor-pointer">
              Aplicar cores a todos
            </Label>
          </div>

          <TabsContent value="colors" className="mt-0">
            <div id="panel-color" className="rounded-lg border bg-card p-1">
              <div className="function">
                <ColorPicker value={color} onChange={handleColorChange} />
              </div>
            </div>
          </TabsContent>

          <TabsContent value="my-colors" className="mt-0">
            <div id="panel-my-colors" className="rounded-lg border bg-card p-4">
              <div className="flex items-center gap-2 mb-3">
                <Select value={selectedTableId} onValueChange={handleTableSelect}>
                  <SelectTrigger id="my-colors-table-select" className="w-full h-9 text-sm">
                    <SelectValue placeholder="Selecione a tabela de cores" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="default">Padrão (cores cadastradas)</SelectItem>
                    {colorTables.map((table) => (
                      <SelectItem key={table.id} value={table.id}>
                        {table.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <Button
                  variant="outline"
                  size="sm"
                  className="h-9 px-2.5 flex-shrink-0"
                  title="Cadastrar / gerenciar tabelas de cores"
                  onClick={handleManageTables}
                >
                  <Plus className="h-4 w-4" />
                </Button>
              </div>
              <div className="function">
                <div id="my-colors-svg" className="grid grid-cols-5 gap-2 justify-center max-h-[300px]">
                  {myColors.length === 0 ? (
                    <span className="col-span-5 text-xs text-muted-foreground text-center py-2">
                      Nenhuma cor encontrada na tabela selecionada
                    </span>
                  ) : myColors.map((color, index) => (
                    <div
                      key={index}
                      className="colorNew w-6 h-6 rounded cursor-pointer border"
                      style={{ backgroundColor: color.hex }}
                      data-r={color.r}
                      data-g={color.g}
                      data-b={color.b}
                      title={color.hex}
                      onClick={() => handleColorChange(color.hex)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  )
}

export default SelectionColorSettings
